export default __webpack_public_path__ + "static/media/pl_thailand_08092564.8e794a95.jpg";